<template >
  <div
    v-if="Object.keys(inputObj.val).length  > 0"
    class="list-group"
  >
    <template
      v-for="item in inputObj.val"

    >



      <div
          v-if="item.hide !== true"
        class="list-group-item"
      >
      <template v-if="item.format == 'bool'">

        <span
          :class="item.value? 'text-success' : 'text-danger'"
        >
        <i
            v-if="item.value"
            class="bi bi-check-circle-fill text-success"
        />
        <i
            v-else-if="!item.value"
            class="bi bi-x-circle-fill text-danger"
        />

        <span class="ms-2">{{item.title}}</span>        </span>

      </template>

      <template
        v-else-if="item.format == 'price'"
      >
        <span class="text-muted me-2">{{item.title}}:</span>
        <span>
          {{ formatDisplayPrice(item.value, item.sufix) }}
        </span>
      </template>

      <template
          v-else-if="item.format == 'link'"
      >
        <span class="text-muted me-2">{{item.title}}:</span>
        <a
          :href="(item.definition.link.protocol? item.definition.link.protocol: '') + item.value"
          :class="(item.definition.link.class? item.definition.link.class: ' btn btn-link')"
        >
          {{ (item.definition.link.title? item.definition.link.title: item.value) }}
         </a>
      </template>

      <template
          v-else-if="item.format == 'children'"
      >
          [kids]
      </template>

      <template
          v-else-if="item.format == 'btn_modal'"
      >

          <span class="text-muted me-2">{{item.title}}:</span>

          <div
            class="btn btn-sm btn-outline-primary"
            @click.prevent="openModal(item.value, item.definition.router)"
          >
            <i
              v-if="item.definition.btn.ico"
              :class="item.definition.btn.ico + ' me-1'"
            ></i>
            {{item.definition.btn.title}}
         </div>

      </template>

      <template
          v-else-if="item.format == 'datetime'"
      >
        <span class="text-muted me-2">{{item.title}}:</span>
        <template
          v-if="item.value"
        >

          {{ formatDisplayDatetime(item.value, $i18n.locale) }}
          <!--
          <pre>{{item.value}}</pre>
          -->
        </template>
        <template
          v-else
        >
          [neni datetime]
        </template>

     </template>

      <template
          v-else-if="item.format == 'date'"
      >
        <span class="text-muted me-2">{{item.title}}:</span>
        {{ formatDisplayDate(item.value, $i18n.locale)}}
      </template>

        <template
            v-else-if="item.format == 'date_range'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          <!--
          <pre>d range 1: {{item.value}}</pre>
          -->
          {{ formatDisplayRangeDate(item.value, $i18n.locale)}}

        </template>
        <template
            v-else-if="item.format == 'datetime_range'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>

          {{ formatDisplayRangeDatetime(item.value, $i18n.locale)}}
        </template>

        <template v-else>
        <span class="text-muted me-2">{{item.title}}:</span>
        <span>

          <span v-if="item.prefix" class="me-1"> {{item.prefix}}</span>

          {{item.value}}
          <span v-if="item.sufix" class="ms-1"> {{item.sufix}}</span>
        </span>

      </template>
      </div>
    </template>
  </div>
  <div
    v-else
    class="text-center p-3"
  >
    <i class="bi bi-sign-stop"></i>
    Nejsou zadna data pro json zobrazeni
  </div>

<!-- modal start -->
  <div
      v-if="
        modalOpen
        && modalOpen.config
        && modalOpen.config.display
      "
  >
    <modal-window
        :title="modalOpen.title"
        :config="modalOpen.config"
    >
      <template #modal-content-slot>
        <component
            v-bind:is="'ContentIncludeView'"
            :router="modalOpen.router"
            :return-data="modalOpen.data"
            :form-prefill="modalOpen.prefill"
            :config="modalOpen.config"
        ></component>
      </template>
    </modal-window>
  </div>
<!-- modal end -->

</template>

<script>

import axios from "axios";
import ContentIncludeView from "@/views/ContentIncludeView";
import ModalWindow from '@/components/content/ModalWindow'
import {
  formatDisplayDate,
  formatDisplayDatetime,
  formatDisplayRangeDate,
  formatDisplayRangeDatetime
} from "@/utils/general";
export default {
  name: "JsonDisplay",
  components: {
    ContentIncludeView,
    ModalWindow,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},
      modal: {
        title: 'vychozi okno title',
        router: {
          //modul: this.getApiConfig('reservation.module'),
          //action_template: 'detail',
          //: 'detail'

          //modul: this.inputObj.templates.router.module,
          //action_template: this.inputObj.templates.router.action,
          //action: this.inputObj.templates.router.action


        },
        config: {
          "display": true,
          "is_header": true,
          "is_close_btn": true,
          "is_footer": true
        },
        data: {
          save: false,
          submit: false,
        },
        prefill: {
          general: {
            inputs: {
              id: {
                readonly: true,
                //value: this.inputObj.val
                value: null
              },
            }
          },
        },
      },
      modalOpen: {},
    }
  },
  created() {
    //this.inputModel = {};
    /*
    if(
        this.inputObj.templates.currency
    ) {
      for(const key in this.inputObj.templates.currency) {
        const types = {}
        for(const t in this.inputObj.templates.type) {
          types[t] = {
            condition: this.inputObj.templates.type[t].condition,
            isDisplay: true,
            value: null

          }; //null
        }
        this.inputModel[this.inputObj.templates.currency[key].ident] = types;
      }
    }
  */
  },
  mounted() {

  },
  methods: {
    formatDisplayRangeDatetime,
    formatDisplayRangeDate,
    formatDisplayDate,
    formatDisplayDatetime,
    openModal(id,configuration) {
      this.modal.data.submit = false;
      this.modal.data.saved = false;
      this.modal.config.display = true;

      this.modalOpen = {...this.modal};
      this.modalOpen.title = configuration.title;
      this.modalOpen.router.modul = configuration.module;
      this.modalOpen.router.action = this.getRouterAction(configuration.action, id)
    },

    getRouterAction(prefix, id) {
        return prefix + '/' + id + '?lang_code=' + this.$i18n.locale;
    }
  },
  watch: {
    /*
    inputModel: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },
    "modals.reservation_view.data.data": {
      handler(newVal) {
        if(newVal){
          console.log('dev.menu modals modals.reservation_view.data', newVal)


          this.modals.reservation_view.data.submit = true;
          this.modals.reservation_view.data.saved = true;
          this.modals.reservation_view.config.display = false;
        }

        //console.log('dev.menu modals modals.section_create.data', newVal)
      },
      deep: true,
      immediate: true
    },
    */
  },
};
</script>